import {
  GET_REPORTS_CURRENT_ORDERS,
  GET_REPORTS_CENTER_ORDERS,
} from './constants';

export function getReportsCurrentOrdersAction(payload: Object) {
  return {
    type: GET_REPORTS_CURRENT_ORDERS,
    payload,
  };
}

export function getReportsCenterOrdersAction(payload: Object) {
  return {
    type: GET_REPORTS_CENTER_ORDERS,
    payload,
  };
}
